import { useEffect } from "react"

import { Divider, Flex, Typography } from "antd"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

import ButtonComponent from "../../Components/Button"
import Icon from "../../Icon"
import { getBalance } from "../Balance/redux/balance.thunks"
import Balance from "./Balance"
import Billing from "./Billing"
import { usePageQuery } from "./usePageQuery"

const { Title, Text } = Typography

export const UserBalancePageForAdmin = () => {
  const { search } = useLocation()
  const { user_id, from } = usePageQuery(search)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (user_id) dispatch(getBalance({ user_id }))
  }, [user_id])

  return (
    <div style={{ padding: "32px 0 0" }}>
      <Flex gap={8} align="flex-start" style={{ padding: "0 32px" }}>
        <ButtonComponent
          type="text"
          icon={<Icon type="arrow_left" />}
          style={{ width: 32 }}
          onClick={() => navigate(from ? decodeURIComponent(from) : "/users")}
        />
        <Flex vertical gap={4}>
          <Title level={4} style={{ margin: 0 }}>
            User Balance
          </Title>
          <Text type="secondary">All information about users billing and invoices.</Text>
        </Flex>
      </Flex>

      <div style={{ padding: "0 32px" }}>
        <Divider />
      </div>
      <Balance />
      <div style={{ padding: "0 32px" }}>
        <Divider style={{ margin: 0 }} />
      </div>
      <Billing fullInfo={true} />
    </div>
  )
}
